
import Vue from "vue";
export default Vue.extend({
  name: "ProjectDetailsOverlay",
  props: {
    visible: Boolean,
    color: String,
    title: String,
    htmlContent: String,
    iconUrl: { type: String, default: "" },
  },
  data() {
    return { lightboxSrc: "" };
  },
  watch: {
    visible(val: boolean) {
      if (!val) this.lightboxSrc = "";
    }
  },
  methods: {
    onContentClick(e: MouseEvent) {
      const target = e.target as HTMLElement;
      if (target.tagName === "IMG" && !target.getAttribute("src")?.includes("badge-color") && !target.getAttribute("src")?.includes("github.png")) {
        this.lightboxSrc = (target as HTMLImageElement).src;
      }
    }
  }
});
